import { Table } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import AgentBranchCell from '../components/AgentBranchCell';
import TrendCell from '../components/TrendCell';

export default function ConversionRateTableRow({ row }) {
  const {
    id,
    agent,
    branch,
    conversion_rate,
    assigned_contacts,
    with_visits,
    with_reservations,
    concreted,
    lost,
    in_progress,
  } = row;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <AgentBranchCell
          agentId={agent?.id}
          agentName={agent?.name}
          branchName={branch?.name}
          image={agent?.profile_picture}
          relativeSelector="#conversion-rate-modal"
          withImage
          withBranch
          withBoldTitle
          modal="conversionRate"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={conversion_rate?.value}
          variation={conversion_rate?.variation}
          percentageStatus={conversion_rate?.percentage_status}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={assigned_contacts?.value}
          variation={assigned_contacts?.variation}
          percentageStatus={assigned_contacts?.percentage_status}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={with_visits?.value}
          variation={with_visits?.variation}
          percentageStatus={with_visits?.percentage_status}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={with_reservations?.value}
          variation={with_reservations?.variation}
          percentageStatus={with_reservations?.percentage_status}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={concreted?.value}
          variation={concreted?.variation}
          percentageStatus={concreted?.percentage_status}
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell
          value={lost?.value}
          variation={lost?.variation}
          percentageStatus={lost?.percentage_status}
          invertColors
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <TrendCell value={in_progress?.value} hideTrend />
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
